/* External */
import { useMemo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import PlayOffsOtt from '@dtvgo/plays-off';

/* Components */
import ScrollIntoViewIfFocused from '../ScrollIntoViewIfFocused';

/* Utils */
import { ScrollPosition } from '../ScrollView';
import { useIsBrazil } from '../../providers/ConfigProvider';

/* Styles */
import './PlayOffs.scss';

function PlayOffs({
  title,
  item: standing,
}) {
  const parsedStanding = useMemo(() => ({
    ...standing,
    playoffStages: standing?.playoffStages?.map((stage) => ({
      ...stage,
      matches: stage?.matches?.map((match) => ({
        ...match,
        home: {
          ...match?.home,
          team: {
            ...match?.home?.team,
            images: Object.values(match?.home?.team?.images),
          },
        },
        away: {
          ...match?.away,
          team: {
            ...match?.away?.team,
            images: Object.values(match?.away?.team?.images),
          },
        },
      })),
    })),
  }), [standing]);

  const isBrazil = useIsBrazil();

  return (
    <ScrollIntoViewIfFocused position={ScrollPosition.CENTER}>
      {title && (
        <h3 className="dtv-html5-c-play-offs__title">
          {title}
        </h3>
      )}
      <PlayOffsOtt
        standing={parsedStanding}
        className={
          `dtv-html5-c-play-offs ${isBrazil ? '' : 'dtv-play-offs--color-hispam'}`
        }
        currentStageDarkBackground={!isBrazil}
      />
    </ScrollIntoViewIfFocused>
  );
}

PlayOffs.propTypes = {
  title: PropTypes.string.isRequired,
  item: PropTypes.shape().isRequired,
};

export default PlayOffs;
